import Header from "../components/Header";
import React, {
  useEffect,
  useState
} from "react";

import axios from "axios";
import { useCart } from "../context/CartContext";
import {
  useParams
} from "react-router-dom";

import config from "../config";

const ProductDetails = () => {

  const { id } = useParams();
  const { addToCart } = useCart();
  const [product, setProduct] =
    useState(null);

  const [loading, setLoading] =
    useState(true);

  // =========================
  // LOAD PRODUCT
  // =========================

  const loadProduct = async () => {

    try {

      const res = await axios.get(
        `${config.API_BASE_URL}/api/products/${id}`
      );

      setProduct(res.data.data);

    } catch (err) {

      console.error(
        "LOAD PRODUCT ERROR:",
        err
      );
    }

    setLoading(false);
  };

  useEffect(() => {

    loadProduct();

  }, [id]);

  // =========================
  // LOADING
  // =========================

  if (loading) {

    return (
      <div style={styles.loading}>
        Loading...
      </div>
    );
  }

  // =========================
  // NOT FOUND
  // =========================

  if (!product) {

    return (
      <div style={styles.loading}>
        Product not found
      </div>
    );
  }

  return (

    <div style={styles.page}>
    <Header />
      <div style={styles.card}>

        {/* IMAGE */}

        <div style={styles.imageBox}>

          <img
            src={
              product.image
                ? `${config.IMAGE_BASE_URL}/${product.image}`
                : "https://via.placeholder.com/500"
            }
            alt={product.name}
            style={styles.image}
          />

        </div>

        {/* DETAILS */}

        <div style={styles.details}>

          <h1 style={styles.name}>
            {product.name}
          </h1>

          <p style={styles.category}>
            Category:
            {" "}
            {product.categoryname || "N/A"}
          </p>

          <h2 style={styles.price}>
            ₹{Number(product.price).toFixed(2)}
          </h2>

          <p style={styles.stock}>
            Stock:
            {" "}
            {product.stock}
          </p>

          <p style={styles.description}>
            {
              product.description ||
              "No description available"
            }
          </p>

          <button
  style={styles.cartBtn}
  onClick={() => {

    addToCart(product);

    alert("Product added to cart");

  }}
>
  Add To Cart
</button>

        </div>

      </div>

    </div>
  );
};

export default ProductDetails;

// =========================
// STYLES
// =========================

const styles = {

  page: {
    padding: 30,
    background: "#f5f5f5",
    minHeight: "100vh"
  },

  card: {
    background: "#fff",
    borderRadius: 15,
    padding: 25,
    display: "grid",
    gridTemplateColumns:
      "1fr 1fr",
    gap: 40,
    alignItems: "center"
  },

  imageBox: {
    textAlign: "center"
  },

  image: {
    width: "100%",
    maxWidth: 500,
    borderRadius: 12,
    objectFit: "cover"
  },

  details: {
    display: "flex",
    flexDirection: "column",
    gap: 15
  },

  name: {
    margin: 0
  },

  category: {
    color: "#666",
    fontSize: 16
  },

  price: {
    color: "#e91e63",
    margin: 0
  },

  stock: {
    fontWeight: "bold"
  },

  description: {
    lineHeight: 1.8,
    color: "#444"
  },
cartBtn: {
  background: "linear-gradient(135deg, #ff9800, #ff5722)",
  color: "#fff",
  border: "none",
  padding: "16px 24px",
  borderRadius: 12,
  cursor: "pointer",
  fontWeight: "bold",
  fontSize: 16,
  width: "100%",
  marginTop: 20,
  transition: "0.3s",
  boxShadow: "0 6px 18px rgba(255,87,34,0.25)"
},
  button: {
    background: "#000",
    color: "#fff",
    border: "none",
    padding: "14px 20px",
    borderRadius: 10,
    cursor: "pointer",
    width: 220,
    fontSize: 16,
    marginTop: 10
  },

  loading: {
    padding: 40,
    textAlign: "center",
    fontSize: 22
  }
};